/**
 * Minifigs 2.0 - Apply torso image overlay to product media gallery items
 *
 *
 * @author Benjamin Wilson <benjamin.wilson@four.agency>
 * @package Joi Polloi
 */

const switcherFront = document.querySelectorAll('.buybits-torso-switcher .show-front');
const switcherBack = document.querySelectorAll('.buybits-torso-switcher .show-back');

// Debounce function to limit how often a function can be called
const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

/**
 * Toggle active class between front and back torso images
 */
const buyBitsFormTorsoOverlay = () => {
    console.log({ switcherFront, switcherBack });
    // Function to check if the current active slide is the product-thumbnail
    const checkProductThumbnail = debounce(() => {
        const activeSlide = document.querySelector('.swiper-product-media-gallery .swiper-slide-active');
        const isThumbnail = activeSlide && activeSlide.classList.contains('product-thumbnail');

        // Get all torso switchers
        const torsoSwitchers = document.querySelectorAll('.buybits-torso-switcher');

        if (isThumbnail) {
            // Disable and add half opacity to the torso switchers
            torsoSwitchers.forEach((switcher) => {
                switcher.classList.add('disabled');
                switcher.style.opacity = '0.5';
                switcher.querySelectorAll('button').forEach((btn) => {
                    btn.disabled = true;
                });
            });
        } else {
            // Re-enable the torso switchers
            torsoSwitchers.forEach((switcher) => {
                switcher.classList.remove('disabled');
                switcher.style.opacity = '1';
                switcher.querySelectorAll('button').forEach((btn) => {
                    btn.disabled = false;
                });
            });
        }
    }, 50); // 50ms debounce

    // Add click event listeners to the front switcher buttons
    if (switcherFront.length) {
        switcherFront.forEach((button) => {
            button.addEventListener('click', () => {
                document
                    .querySelectorAll('.swiper-product-media-gallery, .swiper-product-media-thumbs')
                    .forEach((el) => {
                        el.classList.remove('show-back');
                        el.classList.add('show-front');

                        // Show front images, hide back images
                        el.querySelectorAll('.front-image').forEach((img) => (img.style.display = 'block'));
                        el.querySelectorAll('.back-image').forEach((img) => (img.style.display = 'none'));

                        // Handle slides with data-imagecompare
                        el.querySelectorAll('.swiper-slide').forEach((slide) => {
                            const dataImageCompare = slide.getAttribute('data-imagecompare') || '';
                            if (dataImageCompare.includes('-back')) {
                                slide.style.display = 'none';
                            } else if (dataImageCompare.includes('-front') || !dataImageCompare.includes('-back')) {
                                slide.style.display = '';
                            }
                        });

                        // Show overlays
                        el.querySelectorAll('.torsoOverlayValue__dark, .torsoOverlayValue__colour').forEach(
                            (overlay) => {
                                overlay.classList.remove('hide-overlay');
                            }
                        );
                    });

                // Update active class on buttons
                document.querySelectorAll('.buybits-torso-switcher .show-back').forEach((btn) => {
                    btn.classList.remove('active');
                });
                document.querySelectorAll('.buybits-torso-switcher .show-front').forEach((btn) => {
                    btn.classList.add('active');
                });
            });
        });
    }

    // Add click event listeners to the back switcher buttons
    if (switcherBack.length) {
        switcherBack.forEach((button) => {
            button.addEventListener('click', () => {
                document
                    .querySelectorAll('.swiper-product-media-gallery, .swiper-product-media-thumbs')
                    .forEach((el) => {
                        console.log({ el });
                        el.classList.remove('show-front');
                        el.classList.add('show-back');

                        // Show back images, hide front images
                        el.querySelectorAll('.front-image').forEach((img) => (img.style.display = 'none'));
                        el.querySelectorAll('.back-image').forEach((img) => (img.style.display = 'block'));

                        // Hide overlays but never hide the active slide overlay
                        el.querySelectorAll('.torsoOverlayValue__dark, .torsoOverlayValue__colour').forEach(
                            (overlay) => {
                                // If this overlay is part of the active slide, don't hide it
                                if (
                                    overlay.classList.contains('swiper-slide-active') ||
                                    overlay.closest('.swiper-slide-active')
                                ) {
                                    overlay.classList.remove('hide-overlay');
                                } else {
                                    overlay.classList.add('hide-overlay');
                                }
                            }
                        );
                    });

                // Update active class on buttons
                document.querySelectorAll('.buybits-torso-switcher .show-front').forEach((btn) => {
                    btn.classList.remove('active');
                });
                document.querySelectorAll('.buybits-torso-switcher .show-back').forEach((btn) => {
                    btn.classList.add('active');
                });
            });
        });
    }

    // Set up a MutationObserver to watch for changes to the active slide
    const galleryContainers = document.querySelectorAll('.swiper-product-media-gallery');
    if (galleryContainers.length) {
        galleryContainers.forEach((container) => {
            // Create a single observer for the container
            const observer = new MutationObserver(
                debounce(() => {
                    // Only process once regardless of how many mutations occurred
                    checkProductThumbnail();
                    initializeImages();
                }, 50)
            ); // 50ms debounce

            // Only observe the container itself, not all individual slides
            observer.observe(container, {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true, // Will catch changes to child elements
                childList: false, // We don't need to track DOM node additions/removals
            });
        });

        // Also check on initial load
        checkProductThumbnail();
    }

    // Listen for Swiper events
    document.addEventListener('DOMContentLoaded', () => {
        // Wait for custom element to be defined
        const initSwiperListener = debounce(() => {
            // Get the gallery component
            const galleryComponent = document.querySelector('product-media-gallery');
            if (galleryComponent && galleryComponent.gallery) {
                galleryComponent.gallery.on(
                    'slideChange',
                    debounce(() => {
                        checkProductThumbnail();
                        // Don't call initializeImages here as it will be called by the MutationObserver
                    }, 50)
                );
            } else if (document.querySelector('product-media-gallery')) {
                // Try again in a moment if the gallery exists but isn't fully initialized
                setTimeout(initSwiperListener, 500);
            }
        }, 50);

        // Start the initialization process
        setTimeout(initSwiperListener, 500);
    });
};

// Function to initialize back/front images based on current state
const initializeImages = debounce(() => {
    const isShowingBack = document.querySelector('.swiper-product-media-gallery.show-back') !== null;

    // Use requestAnimationFrame to batch DOM updates
    requestAnimationFrame(() => {
        document.querySelectorAll('.swiper-product-media-gallery, .swiper-product-media-thumbs').forEach((el) => {
            // Handle media-swiper-torso elements
            if (isShowingBack) {
                el.querySelectorAll('.front-image').forEach((img) => (img.style.display = 'none'));
                el.querySelectorAll('.back-image').forEach((img) => (img.style.display = 'block'));
            } else {
                el.querySelectorAll('.front-image').forEach((img) => (img.style.display = 'block'));
                el.querySelectorAll('.back-image').forEach((img) => (img.style.display = 'none'));
            }

            // Properly handle overlays on active slides
            el.querySelectorAll('.torsoOverlayValue__dark, .torsoOverlayValue__colour').forEach((overlay) => {
                if (isShowingBack) {
                    // If this overlay is part of the active slide, don't hide it
                    if (overlay.classList.contains('swiper-slide-active') || overlay.closest('.swiper-slide-active')) {
                        overlay.classList.remove('hide-overlay');
                    } else {
                        overlay.classList.add('hide-overlay');
                    }
                } else {
                    overlay.classList.remove('hide-overlay');
                }
            });
        });
    });
}, 50);

// Initialize the functionality
document.addEventListener('DOMContentLoaded', () => {
    buyBitsFormTorsoOverlay();

    // Initialize image visibility once the DOM is fully loaded
    setTimeout(() => {
        initializeImages();
    }, 500);
});

export default buyBitsFormTorsoOverlay;
